import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';
import { InputBase } from '@mui/material';


export const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;


export const FilterContainer = styled.div`
  position: relative;
  display: inline-block;
`;

export const FilterContent = styled.div`
  position: absolute;
  top: 100%;
  right: 0;
  background: white;
  border-radius: 20px;
  z-index: 1000;
  width: 752px;
  max-height: 600px;
  overflow: hidden;
  animation: ${fadeIn} 0.3s ease-in-out;
`;

export const ScrollableContent = styled.div`
  max-height: 500px;
  overflow-y: auto;
  padding: 0 12px;
  
  &::-webkit-scrollbar {
    width: 1px;
    border-radius: 10px;
  }
  
  &::-webkit-scrollbar-track {
    background: transparent !important;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #575758;
    border-radius: 10px;
  }
  
  &::-webkit-scrollbar-thumb:hover {
    background: #F4762A;
  }
  
  scrollbar-width: thin;
  scrollbar-color: #575758 transparent;
`;


export const FilterAccordion = styled.div`
  box-shadow: none;
  background-color: transparent;
  transition: all 0.3s ease;
  
  &.expanded {
    margin: 4px 0;
    border-radius: 8px;
    background-color: #FEF1EA10;
  }
`;

export const FilterAccordionSummary = styled.div`
  padding: 12px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  
  &.expanded {
    min-height: 48px;
    background-color: #FEF1EA;
    border-radius: 8px;
  }
  
  &:hover {
    background-color: #f5f5f5;
    border-radius: 8px;
  }
  
  & .expand-icon {
    transition: transform 0.3s ease-in-out;
    color: #666666;
  }
  
  &.expanded .expand-icon {
    transform: rotate(180deg);
    color: #F4762A;
  }
  
  &:focus-within {
    background-color: #FEF1EA80;
    border-radius: 8px;
  }
  
  & .section-title {
    font-weight: 500;
    transition: color 0.2s ease;
  }
  
  &.expanded .section-title {
    color: #F4762A;
    font-weight: 600;
  }
`;

export const FilterAccordionDetails = styled.div`
  padding: 16px 16px;
  max-height: 270px;
  overflow-y: auto;
  margin-top: 8px;
  background: #fff;
  border-radius: 8px;
  animation: ${fadeIn} 0.3s ease-in-out;
  
  &::-webkit-scrollbar {
    width: 1px;
    border-radius: 10px;
  }
  
  &::-webkit-scrollbar-track {
    background: transparent !important;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #575758;
    border-radius: 10px;
  }
  
  &::-webkit-scrollbar-thumb:hover {
    background: #F4762A;
  }
  
  scrollbar-width: thin;
  scrollbar-color: #575758 transparent;
  
  &.price-section {
    max-height: none;
    overflow-y: visible;
  }
`;

export const Divider = styled.div`
  height: 1px;
  background-color: #f0f0f0;
  margin: 8px 0;
`;


export const PriceInput = styled(InputBase)`
  width: 100%;
  height: 43px;
  border-radius: 40px;
  padding: 12px 24px;
  border: 1px solid #D3D3D3;
  background: #FFFFFF;
  font-family: 'Prompt', sans-serif;
  font-size: 16px;
  font-weight: 400;
  
  &:hover, &.Mui-focused {
    border: 1px solid #F4762A;
  }
`;


export const PriceInputContainer = styled.div`
  margin-bottom: 8px;
`;

export const PriceButtonScrollContainer = styled.div`
  max-height: 120px;
  overflow-y: auto;
  
  &::-webkit-scrollbar {
    width: 1px;
    border-radius: 10px;
  }
  
  &::-webkit-scrollbar-track {
    background: transparent !important;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #575758;
    border-radius: 10px;
  }
  
  &::-webkit-scrollbar-thumb:hover {
    background: #F4762A;
  }
  
  scrollbar-width: thin;
  scrollbar-color: #575758 transparent;
`;


export const FilterButton = styled.button`
  background-color: #ffffff;
  border-radius: 25px;
  padding: 8px 16px;
  box-shadow: none;
  text-transform: none;
  min-width: 259px;
  height: 40px;
  text-align: left;
  justify-content: flex-start;
  border: 1px solid #D3D3D3;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: 'Prompt', sans-serif;
  font-size: 14px;
  color: #333;
  
  &:hover {
    background-color: #f5f5f5;
    border: 1px solid #F4762A;
    box-shadow: none;
  }
  
  &:active {
    background-color: #f5f5f5;
    border: 1px solid #F4762A;
  }
`;

export const PriceButton = styled.button`
  border-radius: 10px;
  padding: 12px;
  text-transform: none;
  color: #575758;
  background-color: #ffffff;
  font-size: 16px;
  font-weight: 400;
  font-family: 'Prompt', sans-serif;
  width: 100%;
  height: auto;
  display: flex;
  justify-content: flex-start;
  border: none;
  cursor: pointer;
  
  &:hover {
    background-color: #f5f5f5;
  }
`;

export const ActionButton = styled.button`
  border-radius: 25px;
  padding: 8px 24px;
  text-transform: none;
  box-shadow: none;
  cursor: pointer;
  font-family: 'Prompt', sans-serif;
  font-size: 14px;
  font-weight: 500;
  min-width: 120px;
  height: 40px;
  
  &.outlined {
    background-color: transparent;
    border: 1px solid #D3D3D3;
    color: #666666;
    
    &:hover {
      border-color: #F4762A;
      color: #F4762A;
    }
  }
  
  &.contained {
    background-color: #F4762A;
    border: 1px solid #F4762A;
    color: white;
    
    &:hover {
      background-color: #e06521;
      border-color: #e06521;
    }
  }
`;

export const ActionButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 16px;
  position: sticky;
  bottom: 0;
  background-color: #fff;
  z-index: 10;
  gap: 12px;
`;


export const BedroomButtonContainer = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: flex-start;
`;

export const BedroomButton = styled.button`
  min-width: 48px;
  height: 42px;
  border-radius: 25px;
  padding: 8px 16px;
  text-transform: none;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  font-family: 'Prompt', sans-serif;
  transition: all 0.2s ease;
  border: 1px solid #d3d3d3;
  background-color: white;
  color: #666666;
  
  &:hover {
    border-color: #F4762A;
    background-color: #f5f5f5;
  }
  
  &.selected {
    background-color: #F4762A;
    border-color: #F4762A;
    color: white;
  }
`;

export const BathroomButtonContainer = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: flex-start;
`;

export const BathroomButton = styled.button`
  min-width: 48px;
  height: 42px;
  border-radius: 25px;
  padding: 8px 16px;
  text-transform: none;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  font-family: 'Prompt', sans-serif;
  transition: all 0.2s ease;
  border: 1px solid #d3d3d3;
  background-color: white;
  color: #666666;
  
  &:hover {
    border-color: #F4762A;
    background-color: #f5f5f5;
  }
  
  &.selected {
    background-color: #F4762A;
    border-color: #F4762A;
    color: white;
  }
`;

export const QuotaButtonContainer = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: flex-start;
`;

export const QuotaButton = styled.button`
  min-width: 48px;
  height: 42px;
  border-radius: 25px;
  padding: 8px 16px;
  text-transform: none;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  font-family: 'Prompt', sans-serif;
  transition: all 0.2s ease;
  border: 1px solid #d3d3d3;
  background-color: white;
  color: #666666;
  
  &:hover {
    border-color: #F4762A;
    background-color: #f5f5f5;
  }
  
  &.selected {
    background-color: #F4762A;
    border-color: #F4762A;
    color: white;
  }
`;

export const StatusButtonContainer = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: flex-start;
`;

export const StatusButton = styled.button`
  min-width: 48px;
  height: 42px;
  border-radius: 10px;
  padding: 8px 16px;
  text-transform: none;
  cursor: pointer;
  font-size: 16px;
  font-weight: 400;
  font-family: 'Prompt', sans-serif;
  transition: all 0.2s ease;
  border: 0px solid #d3d3d3;
  background-color: white;
  color: #666666;
  display: block;
  text-align: left;
  
  &:hover {
    color: #F4762A;
  }
  
  &.selected {
    color: #F4762A;
  }
`;

export const FloorButtonContainer = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: flex-start;
`;

export const FloorButton = styled.button`
  min-width: 48px;
  height: 42px;
  border-radius: 10px;
  padding: 8px 16px;
  text-transform: none;
  cursor: pointer;
  font-size: 16px;
  font-weight: 400;
  font-family: 'Prompt', sans-serif;
  transition: all 0.2s ease;
  border: 0px solid #d3d3d3;
  background-color: white;
  color: #666666;
  display: block;
  text-align: left;
  
  &:hover {
    color: #F4762A;
  }
  
  &.selected {
    color: #F4762A;
  }
`;

export const ViewButtonContainer = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: flex-start;
`;

export const ViewButton = styled.button`
  min-width: 48px;
  height: 42px;
  border-radius: 10px;
  padding: 8px 16px;
  text-transform: none;
  cursor: pointer;
  font-size: 16px;
  font-weight: 400;
  font-family: 'Prompt', sans-serif;
  transition: all 0.2s ease;
  border: 0px solid #d3d3d3;
  background-color: white;
  color: #666666;
  display: block;
  text-align: left;
  
  &:hover {
    color: #F4762A;
  }
  
  &.selected {
    color: #F4762A;
  }
`;

export const DirectionButtonContainer = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: flex-start;
`;

export const DirectionButton = styled.button`
  min-width: 48px;
  height: 42px;
  border-radius: 10px;
  padding: 8px 16px;
  text-transform: none;
  cursor: pointer;
  font-size: 16px;
  font-weight: 400;
  font-family: 'Prompt', sans-serif;
  transition: all 0.2s ease;
  border: 0px solid #d3d3d3;
  background-color: white;
  color: #666666;
  display: block;
  text-align: left;
  
  &:hover {
    color: #F4762A;
  }
  
  &.selected {
    color: #F4762A;
  }
`;

export const PublishedByButtonContainer = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: flex-start;
`;

export const PublishedByButton = styled.button`
  min-width: 48px;
  height: 42px;
  border-radius: 10px;
  padding: 8px 16px;
  text-transform: none;
  cursor: pointer;
  font-size: 16px;
  font-weight: 400;
  font-family: 'Prompt', sans-serif;
  transition: all 0.2s ease;
  border: 0px solid #d3d3d3;
  background-color: white;
  color: #666666;
  display: block;
  text-align: left;
  
  &:hover {
    color: #F4762A;
  }
  
  &.selected {
    color: #F4762A;
  }
`;

export const PostedDateButtonContainer = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: flex-start;
`;

export const PostedDateButton = styled.button`
  min-width: 48px;
  height: 42px;
  border-radius: 10px;
  padding: 8px 16px;
  text-transform: none;
  cursor: pointer;
  font-size: 16px;
  font-weight: 400;
  font-family: 'Prompt', sans-serif;
  transition: all 0.2s ease;
  border: 0px solid #d3d3d3;
  background-color: white;
  color: #666666;
  display: block;
  text-align: left;
  
  &:hover {
    color: #F4762A;
  }
  
  &.selected {
    color: #F4762A;
  }
`; 